export default __webpack_public_path__ + "static/careers-nina-signature-85167fb5dc07128bfd352625635cfdc4.svg";